import request from '@/utils/request'

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}

// 获取用户详情
export function getUserDetail(id) {
  return request({
    url: `/user/${id}`,
    method: 'get'
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(id, data) {
  return request({
    url: `/user/${id}`,
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/user/${id}`,
    method: 'delete'
  })
}

// 批量删除用户
export function batchDeleteUsers(ids) {
  return request({
    url: '/user/batch-delete',
    method: 'delete',
    data: { ids }
  })
}

// 更新用户状态
export function updateUserStatus(id, status) {
  return request({
    url: `/user/${id}/status`,
    method: 'put',
    data: { status }
  })
}

// 批量更新用户状态
export function batchUpdateUserStatus(ids, status) {
  return request({
    url: '/user/batch-status',
    method: 'put',
    data: { ids, status }
  })
}

// 重置用户密码
export function resetUserPassword(id, newPassword) {
  return request({
    url: `/user/${id}/reset-password`,
    method: 'put',
    data: { newPassword }
  })
}

// 上传用户头像
export function uploadAvatar(data) {
  return request({
    url: '/user/avatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取用户角色列表
export function getUserRoles() {
  return request({
    url: '/user/roles',
    method: 'get'
  })
}

// 更新个人资料
export function updateProfile(data) {
  return request({
    url: '/user/profile',
    method: 'put',
    data
  })
}

// 修改个人密码
export function updatePassword(data) {
  return request({
    url: '/user/password',
    method: 'put',
    data
  })
}

// 获取用户分组列表
export function getUserGroups(params) {
  return request({
    url: '/user/groups',
    method: 'get',
    params
  })
}

// 分配用户角色
export function assignUserRoles(id, roles) {
  return request({
    url: `/user/${id}/roles`,
    method: 'put',
    data: { roles }
  })
}

// 获取用户组列表
// 导出用户列表
export function exportUserList(params) {
  return request({
    url: '/user/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function getUserPoints(id) {
  return request({
    url: `/user/${id}/points`,
    method: 'get'
  })
}

export function updateUserPoints(id, points) {
  return request({
    url: `/user/${id}/points`,
    method: 'put',
    data: { points }
  })
}

export function addUserPoints(id, points) {
  return request({
    url: `/user/${id}/points/add`,
    method: 'put',
    data: { points }
  })
}

export function batchUpdateUserPoints(userPointsMap) {
  return request({
    url: '/user/batch-points',
    method: 'put',
    data: userPointsMap
  })
}

// 获取用户活动照片列表
export function getActivityPhotos(userId) {
  return request({
    url: `/user/${userId}/activity-photos`,
    method: 'get'
  })
}

// 上传用户活动照片
export function uploadActivityPhoto(userId, file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: `/user/${userId}/activity-photos`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除用户活动照片
export function deleteActivityPhoto(userId, objectKey) {
  return request({
    url: `/user/${userId}/activity-photos`,
    method: 'delete',
    data: { objectKey }
  })
}